import { Action, AnyObject,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, TicketStatus, TicketType } from './index';

export type TicketCreateData = { id: string };

export type TicketCreateResponse = TicketCreateData

export interface TicketCreateBody {
  name: string;
  description: string;
  type: TicketType;
  status: TicketStatus;
  details?: AnyObject;
}

export const ticketCreate = (payload: TicketCreateBody): Action<TicketCreateBody> => ({
  type: actions.ticketCreateTrigger.toString(),
  payload,
});

export const ticketCreateClear = (): Action => ({
  type: actions.ticketCreateClear.toString(),
});

export function* ticketCreateRequestSaga({ payload }: Action<TicketCreateBody>) {
  // eslint-disable-next-line no-unused-expressions,@typescript-eslint/no-unused-expressions
  ({ payload });
  yield put({
    type: actions.ticketCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.ticketCreateError.toString(),
      payload: {
        message: 'TicketCreate: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/tickets`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TicketCreateData, TicketCreateResponse>(
    response,
    actions.ticketCreateSuccess.toString(),
    actions.ticketCreateError.toString(),
    false,
    (ticketCreateData) => ticketCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.ticketCreateTrigger.toString(),
    defaultProcessingSaga(
      ticketCreateRequestSaga,
      {
        error: actions.ticketCreateError.toString(),
        locationCancel: actions.ticketCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.ticketCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.ticketCreateClear.toString(),
    // });
  });

  yield takeLatest(actions.ticketCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.ticketCreateErrorReset.toString(),
    });
  });
}
